import { Contract, utils } from "near-api-js";
import { useEffect, useState } from "react";
import useNear from "./nearHook";

const ENUMERATE_PAGE_SIZE = 10;

const useSbtMarketplace = () => {
  const near = useNear();

  const getContract = async (contractId) => {
    // debugger;
    const contract = await new Contract(
      near.account.wallet.account(),
      contractId,
      {
        viewMethods: [
          "sbt_permissions",
          "sbt_permissions_count",
          "sbt_permissions_metadata",
          "view_listings",
          "view_offers"
        ],
        changeMethods: [
          "create_permission",
          "add_listing",
          "add_offer",
          "accept_offer"
        ],
      }
    );
    return contract;
  };

  const addListing = async (contractId, tokens, price) => {
    try {
      const contract = await getContract(contractId);
      return await contract.add_listing({args: {
        tokens, 
        price: price ? utils.format.parseNearAmount(price) : null
      }});
    } catch {
      return null;
    }
  }

  const getListings = async (contractId) => {
    try {
      const contract = await getContract(contractId);
      console.log("viewing listings")
      return await contract.view_listings();
    } catch(e) {
      console.error(e);
      return [];
    }
  }

  const addOffer = async (contractId, listingId, offerPrice) => {
    try {
      const contract = await getContract(contractId);
      return await contract.add_offer({args: {
          listing_id: listingId,
        },
        amount: offerPrice ? utils.format.parseNearAmount(offerPrice) : undefined
      });
    } catch {
      return null;
    }
  }

  const getOffers = async (contractId, accountId) => {
    try {
      const contract = await getContract(contractId);
      return await contract.view_offers({account_id: accountId});
    } catch(e) {
      console.error(e);
      return [];
    }
  }

  const acceptOffer = async (contractId, listingId, tokenLocators, accounts) => {
    const body = {
      sbt_tokens: tokenLocators,
      accounts: accounts,
    };
    const bodyToSign = JSON.stringify(body);
    console.log(bodyToSign);
    console.log(contractId);
    const sig = await near.account.sign(bodyToSign);

    const contract = await getContract(contractId);
    console.log({args: {
      listing_id: listingId,
      permission: {
        body: body,
        signature: sig.signature,
        public_key: sig.public_key,
      },
    }})

    return await contract.accept_offer({args: {
      listing_id: listingId,
      permission: {
        body: body,
        signature: sig.signature,
        public_key: sig.public_key,
      },
    }});
  }

  const getContractMetadata = async (contractId) => {
    try {
      const contract = await getContract(contractId);
      return await contract.sbt_permissions_metadata();
    } catch {
      return null;
    }
  };

  const createTokenLocator = (contractId, tokenId) => {
    return {
      chain_id: "near",
      sbt_contract_id: contractId,
      token_id: tokenId,
    };
  };

  

  const grantPermissions = async (contractId, tokenLocators, accounts) => {
    console.log(tokenLocators, accounts);
    const body = {
      sbt_tokens: tokenLocators,
      accounts: accounts,
    };
    const bodyToSign = JSON.stringify(body);
    console.log(bodyToSign);
    const sig = await near.account.sign(bodyToSign);

    const contract = await getContract(contractId);

    return await contract.create_permission({
      permission: {
        body: body,
        signature: sig.signature,
        public_key: sig.public_key,
      },
    });
  };

  return {
    addListing,
    getListings,
    addOffer,
    getOffers,
    acceptOffer,
    getContractMetadata,
  };
};

export default useSbtMarketplace;
